import { bon } from './BON';
import { tdlr } from './TDLR';
import { cpa } from './CPA';

export const AGENCY_ERRORS = { bon, tdlr, cpa };
